import { tryGetHostApi } from "./externalApi";
export async function getHostRegistrarApi() {
    return (await tryGetHostApi("Registrar", 1, 1));
}
